import { WarningBanner } from 'ui/banner';
import { Trans } from 'react-i18next';
import { fontWeights } from 'ui/theme';
import { isNonEmptyArray } from 'utils/tsHelpers';
import { useTranslation } from '../hooks/useTranslation';
import { useQueryErrorStateContext } from '../contexts';

export const QueryWarningBanner = () => {
  const { t } = useTranslation();
  const { pathWarnings } = useQueryErrorStateContext();

  return isNonEmptyArray(pathWarnings) ? (
    <Trans
      t={t}
      i18nKey="banner.warning"
      components={{
        bold: <span style={{ fontWeight: fontWeights.bold }} />,
        Banner: <WarningBanner />,
      }}
    />
  ) : null;
};
